export const STEP_STATUS = {
  CURRENT: 'current',
  COMPLETED: 'completed',
  UPCOMING: 'upcoming',
};
